// app/javascript/entrypoints/controllers/exit_reasons_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reasonCheckbox", "customReasonField"]

  connect() {
    console.log("Exit reasons controller connected")
  }

  toggleCustomReason(event) {
    const checkbox = event.target
    const reasonKey = checkbox.dataset.reasonKey
    
    if (reasonKey === 'other_reason') {
      const reasonId = checkbox.value
      const customField = this.customReasonFieldTargets.find(field => 
        field.dataset.reasonId === reasonId
      )
      
      if (customField) {
        if (checkbox.checked) {
          customField.classList.remove('hidden')
          // Rendre le champ obligatoire
          const textarea = customField.querySelector('textarea')
          if (textarea) {
            textarea.required = true
          }
        } else {
          customField.classList.add('hidden')
          // Retirer l'obligation et vider le champ
          const textarea = customField.querySelector('textarea')
          if (textarea) {
            textarea.required = false
            textarea.value = ''
          }
        }
      }
    }
  }
} 